export enum CacheKeys {
  OAUTH_TOKEN = 'oauthToken',
  LOGGED_IN_ON = 'loggedInOn',
  LOGGED_IN_USER = 'loggedInUser',
  SIDE_MENU = 'sideMenuOpen',
  CURRENT_LANGUAGE = 'currentLanguage',
}
